import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  const features = [
    {
      icon: 'fas fa-code',
      title: 'Modern Technologies',
      description: 'We use the latest frameworks and tools to build future-proof solutions that scale with your business.'
    },
    {
      icon: 'fas fa-award',
      title: 'High-Quality Service',
      description: 'Every project is delivered with attention to detail, clean code, and best practices.'
    },
    {
      icon: 'fas fa-eye',
      title: 'Full Transparency',
      description: 'Stay informed throughout the development process with regular updates and open communication.'
    },
    {
      icon: 'fas fa-dollar-sign',
      title: 'Cost Effective',
      description: 'Get premium quality solutions at competitive prices, perfect for startups and growing businesses.'
    }
  ];

  return (
    <section id="whyus" className="whyus">
      <div className="whyus-container">
        <div className="whyus-header">
          <h2 className="section-title">Why Us?</h2>
          <p className="section-subtitle">Why Should You Hire Us?</p>
        </div>
        <div className="whyus-grid">
          {features.map((feature, index) => (
            <div key={index} className="whyus-card">
              <div className="whyus-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="whyus-quote">
          <blockquote>
            "If the plan doesn't work – change the plan, not the goal."
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;

